export default {
  data () {
    return {
      truncatedOptions: [],
      fieldTooltip: false
    }
  },

  methods: {
    // Measured once per render because QSelect recreates option nodes on hover, killing controlled tooltips
    measureOptions () {
      this.$nextTick(() => {
        const labels = document.querySelectorAll('.field-select-popup [data-option-index]')
        this.truncatedOptions = [...labels]
          .filter(isTruncated)
          .map((el) => Number(el.dataset.optionIndex))
      })
    },

    onFieldEnter ({ currentTarget }) {
      this.fieldTooltip = isTruncated(currentTarget.querySelector('.field-select-value'))
    }
  }
}

const isTruncated = (el) => !!el && el.scrollWidth > el.clientWidth
